import { render, staticRenderFns } from "./tempMsgModal.vue?vue&type=template&id=2796962c"
import script from "./tempMsgModal.vue?vue&type=script&lang=js"
export * from "./tempMsgModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports